import { connect } from 'react-redux';

import ReferAFriendView from '../components/Dashboard/ReferAFriend/ReferAFriendView.jsx';

const ReferAFriendContainer = connect()(ReferAFriendView);

export default ReferAFriendContainer;
